@if (displaySpinner()) {
  <div class="td-wb-detailed-loading-indicator">
    @if (hasHeader()) {
      <div class="td-wb-detailed-loading-indicator__header">
        <ng-content select="[tdWbDetailedLoadingIndicatorHeader]" />
      </div>
    }
    <div role="progressbar"
         [attr.aria-live]="ariaLive()"
         aria-label="progress bar"
         [attr.aria-valuenow]="0"
         [attr.aria-valuemin]="0"
         [attr.aria-valuemax]="100"
         [attr.aria-valuetext]="'tdWb.loading.LOADING' | tdWbTranslate">
      <td-wb-detailed-spinner [spinnerSize]="spinnerSize()"
                              class="td-wb-detailed-loading-indicator__spinner" />
    </div>
    @if (hasDesc()) {
      <div class="td-wb-detailed-loading-indicator__desc">
        <ng-content select="[tdWbDetailedLoadingIndicatorDesc]" />
      </div>
    }
  </div>
}


